import { set, get, del, delMany, entries } from 'idb-keyval';
import { addDDError } from '../analytics/datadog';

const DEFAULT_TTL_MS = 30 * 24 * 3600;

interface StoredValue {
  value: unknown;
  expiry: number;
}

const isStoredValue = (data: unknown): data is StoredValue => {
  return (
    data != null &&
    typeof data === 'object' &&
    'value' in data &&
    'expiry' in data
  );
};

const parsedStoredValue = (data: unknown) => {
  if (isStoredValue(data) && data.expiry > Date.now()) {
    return data.value;
  }
  return null;
};

export const idbKV = {
  set: (key: IDBValidKey, value: unknown, ttl: number = DEFAULT_TTL_MS) => {
    const expiry = Date.now() + ttl * 1000;
    return set(key, { value, expiry });
  },
  get: async <T>(key: IDBValidKey) => {
    try {
      const storedData = await get(key);
      return parsedStoredValue(storedData) as T;
    } catch (e) {
      addDDError(e);
      return null;
    }
  },
  del: async (key: IDBValidKey) => {
    return del(key);
  },
  cleanExpiredData: async () => {
    const dataEntries = await entries();
    const deletedKeys = dataEntries
      .filter(([, storedValue]) => {
        return parsedStoredValue(storedValue) == null;
      })
      .map(([key]) => key);

    await delMany(deletedKeys);
  },
};
